export const TEST_TYPES = ['speed', 'reliability', 'block_rate', 'geographic', 'protocol', 'overall'];
export const REGIONS = ['US-East', 'US-West', 'EU-West', 'EU-Central', 'APAC', 'LATAM', 'ME-Africa', 'Global'];
export const PROTOCOLS = ['http', 'https', 'socks5'];

export const BLANK_NEW_RUN = {
  provider_id: '',
  test_type: 'speed',
  region: 'US-East',
  protocol: 'https',
  concurrent_connections: 100,
  total_requests: 1000,
  successful_requests: 990,
  avg_response_time_ms: 250,
};